<form [formGroup]="sumInsuredEditForm">
    <div class="cp_popup-title nx-margin-bottom-s">
        Extra Coverage
    </div>
    <h4>Please key in the sum insured for the following extra coverage.</h4>
    <div nxModalContent style="overflow-x:hidden;">
        <!--===== Large and medium view =====-->
        @if(!mobileView) {
        <div class="nx-hidden-xs nx-hidden-s">
            <div nxLayout="grid nopadding">
                <div nxRow>
                    <div nxCol="12,12,6,6,6,6,6">
                        <p nxCopytext="medium">
                            {{ packageBenefitDescription }}
                        </p>
                    </div>
                    <div nxCol="12,12,6,6,6,6,6" style="display:flex;">
                        <p nxCopytext="medium">
                            {{ sumInsuredDisplay }}
                        </p>
                        <nx-formfield  class ="input-styling">
                            <input nxInput type="text" required formControlName="sumInsured"
                                (change)="onChangeSubCoverSumInsured($event.target)" (input)="onChangeSubCoverSumInsured($event.target)"
                                maxlength="13"/>
                        </nx-formfield>
                    </div>
                </div>
                <div nxRow>
                    <div nxCol="12,12,6,6,6,6,6">
                    </div>
                    <div nxCol="12,12,6,6,6,6,6">
                        <div class="error-container">
                            <nx-message context="error"
                                *ngIf="sumInsuredEditForm.controls['sumInsured']?.hasError('required') && sumInsuredEditForm.controls['sumInsured']?.touched"
                                nxFormfieldNote>
                                <strong>Amount Required.</strong>
                            </nx-message>
                            <nx-error
                                *ngIf="sumInsuredEditForm.controls['sumInsured']?.hasError('min') && sumInsuredEditForm.controls['sumInsured']?.touched"
                                nxFormfieldNote>
                                <strong>Only positive number is allowed</strong>
                            </nx-error>
                            <nx-error
                                *ngIf="!sumInsuredEditForm.controls['sumInsured']?.hasError('min') &&
                  sumInsuredEditForm.controls['sumInsured']?.hasError('pattern') && sumInsuredEditForm.controls['sumInsured']?.touched"
                                nxFormfieldNote>
                                <strong>Maximum sum insured exceeded system limit.</strong>
                            </nx-error>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        }
        @if(mobileView) {
        <div class="nx-hidden-m nx-hidden-l nx-hidden-xl nx-hidden-2xl nx-hidden-3xl">
            <nx-accordion variant="light">
                <nx-expansion-panel class="accordion_remove_btm_space" [expanded]="true">
                    <div nxLayout="grid nopadding">
                        <div nxRow>
                            <div nxCol="12,12,6,6,6,6,6">
                                <p nxCopytext="medium">
                                    {{ packageBenefitDescription }}
                                </p>
                            </div>
                            <div nxCol="12,12,6,6,6,6,6" style="display:flex; padding-top:2px">
                                <p nxCopytext="medium">
                                    {{ sumInsuredDisplay }}
                                </p>
                                <nx-formfield  class ="input-styling">
                                    <input nxInput type="text" required formControlName="sumInsured"
                                        (change)="onChangeSubCoverSumInsured($event.target)" (input)="onChangeSubCoverSumInsured($event.target)"
                                        maxlength="13"/>
                                </nx-formfield>
                            </div>
                        </div>
                        <div nxRow>
                            <div nxCol="12,12,6,6,6,6,6">
                            </div>
                            <div nxCol="12,12,6,6,6,6,6">

                                <div class="error-container">
                                    <nx-message context="error"
                                        *ngIf="sumInsuredEditForm.controls['sumInsured']?.hasError('required') && sumInsuredEditForm.controls['sumInsured']?.touched"
                                        nxFormfieldNote>
                                        <strong>Amount Required.</strong>
                                    </nx-message>
                                    <nx-error
                                        *ngIf="sumInsuredEditForm.controls['sumInsured']?.hasError('min') && sumInsuredEditForm.controls['sumInsured']?.touched"
                                        nxFormfieldNote>
                                        <strong>Only positive number is allowed</strong>
                                    </nx-error>
                                    <nx-error
                                        *ngIf="!sumInsuredEditForm.controls['sumInsured']?.hasError('min') &&
                      sumInsuredEditForm.controls['sumInsured']?.hasError('pattern') && sumInsuredEditForm.controls['sumInsured']?.touched"
                                        nxFormfieldNote>
                                        <strong>Maximum sum insured exceeded system limit.</strong>
                                    </nx-error>
                                </div>
                            </div>
                        </div>
                    </div>
                </nx-expansion-panel>
            </nx-accordion>
        </div>
        }
    </div>
    <div class="nx-margin-top-s">
        <div class="button-container-general">
            <button nxButton="secondary" type="button" (click)="cancelEdit()">Cancel</button>
            <button nxButton="primary" type="button" [disabled]="!sumInsuredEditForm.get('sumInsured')?.value || !sumInsuredEditForm.controls['sumInsured']?.valid" (click)="saveEdit()">SAVE</button>
        </div>
    </div>
</form>